/* hs-eslint ignored failing-rules */
/* eslint-disable react/prop-types */

'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isPublic", "language", "validLocales", "onChange", "optionsFilter", "useBetaLanguages"];
import { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'I18n';
import UISelect from 'UIComponents/input/UISelect';
import sortOptions from '../internal/utils/sortOptions';
import findLanguage from '../internal/utils/findLanguage';
import * as BetaLocales from '../internal/constants/BetaLocales';
import { jsx as _jsx } from "react/jsx-runtime";
const getLocaleOptions = ({
  langValue,
  validLocales,
  optionsFilter
}) => {
  let localeOptions = [];
  if (!langValue) {
    return localeOptions;
  }
  const addToLocaleOptions = locale => {
    return localeOptions.push({
      text: I18n.text(`i18nAddon.locales.${locale}`),
      value: locale
    });
  };
  if (!validLocales) {
    langValue.availableLocale.forEach(locale => addToLocaleOptions(locale));
  } else {
    const localeLookup = {};
    langValue.availableLocale.forEach(locale => localeLookup[locale] = locale);
    validLocales.forEach(locale => {
      if (localeLookup[locale]) {
        addToLocaleOptions(locale);
      }
    });
  }
  if (optionsFilter) {
    localeOptions = localeOptions.filter(optionsFilter);
  }
  return localeOptions.sort(sortOptions);
};
class HubSpotLocaleSelect extends Component {
  constructor(...args) {
    super(...args);
    this.getI18nOptions = (isPublic, useBetaLanguages) => {
      const {
        betaLocales,
        betaPublicLocales
      } = this.props;
      const standardLocales = isPublic ? Object.assign({}, I18n.baseLocales, I18n.publicLocales) : Object.assign({}, I18n.baseLocales);
      if (useBetaLanguages) {
        const betaLocalesToUse = isPublic ? betaPublicLocales : betaLocales;
        return Object.assign({}, standardLocales, betaLocalesToUse);
      }
      return standardLocales;
    };
    this.handleLocaleChange = (value, onChange) => {
      return onChange ? onChange(value) : value;
    };
  }
  componentDidMount() {
    const {
      autoPopulateDefaultLocale,
      language,
      onChange,
      value,
      isPublic,
      useBetaLanguages
    } = this.props;
    if (autoPopulateDefaultLocale && onChange && !value) {
      onChange(findLanguage(this.getI18nOptions(isPublic, useBetaLanguages), language).defaultLocale);
    }
  }
  componentDidUpdate() {
    if (!this.props.autoPopulateDefaultLocale || !this.props.onChange || this.props.value) {
      return null;
    }
    const {
      isPublic,
      useBetaLanguages,
      betaLocales,
      betaPublicLocales
    } = this.props;
    const i18nOptions = this.getI18nOptions(isPublic, useBetaLanguages, betaLocales, betaPublicLocales);
    if (i18nOptions) {
      const selectedLanguage = findLanguage(i18nOptions, this.props.language);
      this.props.onChange(selectedLanguage.defaultLocale);
    }
    return null;
  }
  render() {
    const _this$props = this.props,
      {
        isPublic,
        language,
        validLocales,
        onChange,
        optionsFilter,
        useBetaLanguages
      } = _this$props,
      passThroughProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const i18nOptions = this.getI18nOptions(isPublic, useBetaLanguages);

    // issue: https://git.hubteam.com/HubSpot/I18n/issues/1320
    // because there are differences between the 'no-no' and 'zh-tw' entries in the baseLocales and publicLocales
    // data sets, allow the "language" value from either set when `isPublic` is true
    let hackedLanguage;
    if (isPublic && language === 'no') {
      hackedLanguage = 'no-no';
    }
    if (isPublic && language === 'zh') {
      hackedLanguage = 'zh-tw';
    }
    const langValue = findLanguage(i18nOptions, hackedLanguage || language);
    const options = getLocaleOptions({
      langValue,
      validLocales,
      optionsFilter
    });
    return /*#__PURE__*/_jsx(UISelect, Object.assign({}, passThroughProps, {
      onChange: evt => this.handleLocaleChange(evt.target.value, onChange),
      options: options
    }));
  }
}
HubSpotLocaleSelect.propTypes = {
  autoPopulateDefaultLocale: PropTypes.bool,
  isPublic: PropTypes.bool,
  language: PropTypes.string.isRequired,
  optionsFilter: PropTypes.func,
  useBetaLanguages: PropTypes.bool,
  validLocales: PropTypes.array
};
HubSpotLocaleSelect.defaultProps = {
  isPublic: false,
  useBetaLanguages: false,
  betaLocales: BetaLocales.betaLocales,
  betaPublicLocales: BetaLocales.betaPublicLocales
};
export default HubSpotLocaleSelect;